import React, { PureComponent } from 'react';
import { NavLink } from 'react-router-dom';
import SearchBar from './SearchBar';
import Search from './Search';
import HeaderManager from '../managers/HeaderManager';

class HamburgerMenuPage extends PureComponent {
  constructor() {
    super();
    this.state = { projects: [], searching: false };
    const headMan = new HeaderManager();
    this.menu = headMan.getMenu();
    this.searchProjects = this.searchProjects.bind(this);
    this.emptySearch = this.emptySearch.bind(this);
  }

  searchProjects(projects = []) {
    if (projects.length > 0) {
      this.setState({
        searching: true,
      });
    }

    this.setState({
      projects,
    });
  }

  emptySearch() {
    this.setState({
      projects: [],
      searching: false,
    });
  }

  render() {
    const { searching, projects } = this.state;

    return (
      <div className="font-title-bold hamburger">
        <div className="hamburger__dived" />
        <div className={searching ? 'hamburger__padding__top' : 'hamburger'}>
          <NavLink
            className="navigation__link hamburger__padding hamburger__padding__top"
            activeClassName="navigation__link--active"
            to="/games"
          >
            {this.menu.games}
          </NavLink>

          <NavLink
            className="navigation__link hamburger__padding"
            activeClassName="navigation__link--active"
            to="/more"
          >
            {this.menu.more}
          </NavLink>

          <NavLink
            className="navigation__link hamburger__padding"
            activeClassName="navigation__link--active"
            to="/about"
          >
            {this.menu.about}
          </NavLink>

          <NavLink
            className="navigation__link hamburger__padding"
            activeClassName="navigation__link--active"
            to="/contact"
          >
            {this.menu.contact}
          </NavLink>
        </div>

        <div
          className={
            searching ? 'hamburger__padding hamburger__padding__top' : 'hamburger__padding'
          }
        >
          <SearchBar searchPage={this.searchProjects} emptySearch={this.emptySearch} />
        </div>

        <Search projects={projects} />
      </div>
    );
  }
}

export default HamburgerMenuPage;



// WEBPACK FOOTER //
// ./src/components/HamburgerMenuPage.js